<div class="col col-md-12" *ngIf="grabando">
  <div class="spinner-container">
      <ngx-spinner name="spinnerDetalle" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
          type="ball-grid-beat" [fullScreen]="false">
          <p style="color: white">C a r g a n d o . . . </p>
      </ngx-spinner>
  </div>
</div>

<div class="card add-margin" *ngIf="!grabando">
  <form [formGroup]="contactoForm">
    <div class="card-header">
        <div class="row col-12">
            <h4 class="col-10 card-title">{{ title }}</h4>
            @if (contactoSeleccionado) {
              <button [disabled]="borrando" class="col-2 btn btn-danger" (click)="borrarContacto()">
                <span *ngIf="!borrando">Borrar Contacto</span>
                <div *ngIf="borrando">
                  <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                  <span>Borrando...</span>
                </div>
              </button>
            }
        </div>
    </div>
    <div class="card-body">
      <!--NOMBRE-->
      <div class="row">
        <div class="mb-3 row col-md-12">
          <label for="nombreFormControl" class="col-sm-5 col-form-label">Nombre:</label>
          <div class="col-sm-7">
            <input class="form-control" formControlName="nombreFormControl" maxlength="50">
            <div
              *ngIf="nombreFormControl.invalid && nombreFormControl.errors.required && (nombreFormControl.dirty || nombreFormControl.touched)"
                class="alert alert-danger">Requerido
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="mb-3 row col-md-12">
          <label for="numeroFormControl" class="col-sm-5 col-form-label">Tel&eacute;fono:</label>
          <div class="col-sm-7">
            <input class="form-control" formControlName="numeroFormControl" maxlength="50">
            <div
              *ngIf="numeroFormControl.invalid && numeroFormControl.errors.required && (numeroFormControl.dirty || numeroFormControl.touched)"
                class="alert alert-danger">Requerido
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="mb-3 row col-md-12">
          <label for="emailFormControl" class="col-sm-5 col-form-label">Email: </label>
          <div class="col-sm-7">
            <input class="form-control" formControlName="emailFormControl" maxlength="50">
            <div *ngIf="emailFormControl.invalid && emailFormControl.errors.required && (emailFormControl.dirty || emailFormControl.touched)"
                class="alert alert-danger">Requerido
            </div>
            <div *ngIf="emailFormControl.invalid && emailFormControl.errors.email && (emailFormControl.dirty || emailFormControl.touched)"
                class="alert alert-danger">Formato del email no es válido
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fliud mb-3 border mx-2 p-2">
      <label style="font-weight: bold;" class="col-form-label">Grupos: {{ nombreAeroplanta }}</label>
      <div class="justify-content-center d-flex flex-wrap gap-2">
        <button *ngFor="let boton of botonesGrupo"
            class="btn"
            [ngClass]="boton.seleccionado ? 'btn-success' : 'btn-outline-primary'"
            (click)="seleccionarGrupo(boton)">
          {{ boton.nombre }}
        </button>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-center">
      <button class="btn btn-primary me-2" id="aceptar" [disabled]="!contactoForm.valid" (click)="agregarContacto()">
        <span *ngIf="!grabando">Guardar</span>
        <div *ngIf="grabando" class="d-flex align-items-center">
          <div class="spinner-border text-light spinner-border-sm" role="status"></div>
          <span>Guardando...</span>
        </div>
      </button>
      <button type="button" class="btn btn-secondary" (click)="this.activeModal.close(false)">Cancelar</button>
    </div>
  </form>
</div>
